import { useState } from "react";
import PageContainer from '../common/PageContainer'
import SimpleButton from '../common/SimpleButton'
import imgWallet from "../../assets/images/btn_wallet.webp"
import imgPlus from "../../assets/images/btn_plus.webp"
import logoUSDT from "../../assets/images/logo_usdt.webp"
import logoMOO from "../../assets/images/main_moo_coin.webp"
import greenBtn from "../../assets/images/btn_green.webp"
import brownBtn from "../../assets/images/btn_brown.webp"
import s from './LeadersScreen.module.css'
import LeadersList from "./LeadersList";
import { Trans } from "@lingui/react/macro";
import { RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import FooterNavigation from "../FooterNavigation";
import Modal from "../common/Modal";
import ModalRegister from "../ModalRegister";
import useModal from "../../services/useModal";

const LeadersScreen = () => {
    const leaders = useSelector((state: RootState) => state.game.leaderboard);
    const { metadata } = useSelector((state: RootState) => state.game);

    const [activeList, setActiveList] = useState("topReferrers");
    const selectedLanguage = useSelector((state: RootState) => state.game.user.app_language || "en");
    const titleLangMidStyle = selectedLanguage === "en" ? s.titleMidEN : s.titleMid
    const btnTitleStyle = selectedLanguage === "en" ? s.btnTitleEN : s.btnTitle

    // Register
    const { isOpen: isModalOpenRegister,
        isFadingOut: isFadingOutRegister,
        openModal: openModalRegister,
        closeModal: closeModalRegister } = useModal();

    const openAirdrop = () => {
        if (!metadata.is_airdrop) return;
        openModalRegister();
    }

    return (
        <PageContainer>
            <div className={s.containerTop}>
                <div className={s.innerContainer}>
                    {selectedLanguage === "en" && <>
                        <p className={s.titleEN}>REFER & <br />WIN BIG!</p>
                        <p className={s.textTopEN}>THIS ISN'T JUST REFERRALS <br />— IT'S A WAR FOR REWARDS.</p>
                    </>}
                    {selectedLanguage === "cn" && <>
                        <p className={s.title}>推荐 & <br />赢取大奖！</p>
                        <p className={s.textTop}>这不仅仅是推荐 <br />—— 这是为奖励而战。</p>
                    </>}
                    {selectedLanguage === "ru" && <>
                        <p className={s.title}>ПРИГЛАШАЙ <br />И ПОБЕЖДАЙ!</p>
                        <p className={s.textTop}>Здесь не просто<br /> соревнование — здесь <br />настоящая битва за награды!</p>
                    </>}

                    <div className={s.btnsBox}>
                        <SimpleButton imageUrl={imgWallet} width={6.67} onClick={openAirdrop} />
                        <div className={s.btnPosition}>
                            <SimpleButton imageUrl={imgPlus} width={6.67} onClick={openAirdrop} className={s.btnGlow} />
                        </div>

                    </div>
                </div>
            </div>
            <div className={s.containerMid}>
                <p className={titleLangMidStyle}><Trans>PRIZE POOL:</Trans> <span className={s.green}>$30,000</span></p>
                <p className={s.textMid}><Trans>No games. No mercy. Just rewards. Let's go!</Trans></p>

                <div className={s.btnsListBox}>
                    <SimpleButton
                        className={s.listButton}
                        onClick={() => setActiveList("topReferrers")}
                        imageUrl={activeList === "topReferrers" ? greenBtn : brownBtn}>
                        <p className={`${btnTitleStyle} ${activeList === "topReferrers" ? s.black : s.white}`}>
                            <Trans>TOP 100 REFERRERS</Trans>
                        </p>
                        <div className={s.btnTextBox}>
                            <img className={s.imgLogo} src={logoUSDT} alt="logoUSDT" />
                            <p className={s.btnText}><Trans>Share 5,000 USDT</Trans></p>
                        </div>
                    </SimpleButton>

                    <SimpleButton
                        className={s.listButton}
                        onClick={() => { }}
                        imageUrl={activeList === "randomWinners" ? greenBtn : brownBtn}>
                        <p className={`${btnTitleStyle} ${activeList === "randomWinners" ? s.black : s.white}`}>
                            <Trans>300 RANDOM WINNERS</Trans>
                        </p>
                        <div className={s.btnTextBox}>
                            <img className={s.imgLogoMoo} src={logoMOO} alt="logoMOO" />
                            <p className={s.btnText}><Trans>Share 500,000 $MOO</Trans></p>
                        </div>
                    </SimpleButton>
                </div>
            </div>

            {activeList === "topReferrers" && (
                <LeadersList leadersData={leaders} />
            )}
            {/*{activeList === "randomWinners" && (*/}
            {/*    <LeadersList leadersData={winnersData} />*/}
            {/*)}*/}

            <FooterNavigation />

            {isModalOpenRegister && <Modal closeModal={closeModalRegister} isFadingOut={isFadingOutRegister}>
                <ModalRegister closeModal={closeModalRegister} />
            </Modal>}
        </PageContainer>
    )
}

export default LeadersScreen